/**
 * 媒体列表卡的相对时间(海报/视频/分身三线共用)。
 *
 * 2026-07-15 三线列表对齐:此前只有海报卡有(私有函数写在 PosterDashboardPage 里),视频卡显
 * `toLocaleDateString()` 绝对日期,分身卡**连时间都没有**(后端 DTO 那时也不给 createdAt)。
 * 三线各写各的正是「下次又漂」的来源,故收口到共用 entity 层。
 *
 * 口径沿用海报既有实现(用户已习惯):<1min「刚刚」→ 分/小时/天 → 超 30 天回落绝对日期。
 * 空 / 非法时间返 "—"(而不是 "Invalid Date")。
 */
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "—";
  const diff = Date.now() - t;
  // 未来时间(客户端时钟偏移 / 服务端时区错配)按「刚刚」处理,不显示「-3 分钟前」。
  if (diff < 60000) return "刚刚";
  const min = Math.floor(diff / 60000);
  if (min < 60) return `${min} 分钟前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 小时前`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day} 天前`;
  return new Date(iso).toLocaleDateString();
}

/**
 * 已过时长(「已等待 3 分钟」的那截),用于进行中卡。
 *
 * 与 {@link relativeTime} 的差别:这里是**时长**不是时刻,所以不带「前」、不回落绝对日期
 * (在途任务跑了 30 天只能是卡死了,照样显示「N 天」比显示个日期有用)。
 *
 * 2026-07-16:补这个是为了替掉海报进行中卡里的「预计 N 秒」—— 后端 estimatedSecondsRemaining
 * 从来写死 null,那行 ETA 一次都没渲染过。已等待是前端从 createdAt 就能算的、不骗人的信息。
 * 不足 1 分钟返 null(调用方不渲染),避免刚提交时闪一下「已等待 0 分钟」。
 */
export function elapsedSince(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  const diff = Date.now() - t;
  // 未来时间(时钟偏移)当作刚开始,不显示负数时长。
  if (diff < 60000) return null;
  const min = Math.floor(diff / 60000);
  if (min < 60) return `${min} 分钟`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 小时`;
  return `${Math.floor(hr / 24)} 天`;
}
